<template>
  <a-config-provider :theme="themeConfig">
    <div id="app">
      <component :is="layout">
        <router-view />
      </component>
      <!-- Khôi phục bản ghi bị gián đoạn (tab discard/kill) -->
      <RecordingRecovery />
    </div>
  </a-config-provider>
</template>

<script>

import RecordingRecovery from '@/components/RecordingRecovery.vue'

export default ({
  components: { RecordingRecovery },
  data() {
    return {
      // Theme token dùng chung cho toàn bộ Ant Design (modern light).
      themeConfig: {
        token: {
          colorPrimary: "#1677ff",
          colorLink: "#1677ff",
          colorInfo: "#1677ff",
          borderRadius: 10,
          controlHeight: 38,
          fontFamily:
            "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif",
        },
      },
    };
  },
  computed: {
    // Sets components name based on current route's specified layout, defaults to
    // <layout-default></layout-default> component.
    layout() {
      return "layout-" + ( this.$route.meta.layout || "default" ).toLowerCase() ;
    }
  },
})

</script>
<style lang="scss">
#app {
  padding: 0 !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: var(--background-color);
  min-height: 100vh;
}
*{
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji';
}
</style>
